import { assert } from '../lib/assert-sidecar'
import { l } from '../lib/imports'

let t0 = 0
export const reset = (label: string) => {
  t0 = performance.now()
  mark(label)
}
export const mark = (label: string) => {
  let t1 = performance.now()
  let elapsed = (t1 - t0).toFixed(1)

  console.log('perf|', elapsed + ' ms' + '|', label)
}
reset('init')

let update_t0 = 0
let update_tlast = 0
let updateFrames = 0
let pieParts: any = {}

let updatePerformanceEnabled = false
export const setUpdatePerformanceEnabled = (isEnabled: boolean) => {
  if (isEnabled && !updatePerformanceEnabled) {
    console.log('begin performance logging')
    updateTimingReset()
  }
  if (!isEnabled && updatePerformanceEnabled) {
    console.log('end performance logging')
    reportUpdateTimings()
  }

  updatePerformanceEnabled = isEnabled
}

const updateTimingReset = () => {
  update_t0 = performance.now()
  update_tlast = update_t0
  pieParts = {}
  updateFrames = 0
}
export const updateTimingStart = () => {
  update_t0 = performance.now()
  update_tlast = update_t0
  updateFrames++
}

export const markUpdate = (label: string) => {
  if (updatePerformanceEnabled) {
    let t1 = performance.now()
    let elapsed = t1 - update_tlast
    update_tlast = t1

    // assert.nil(pieParts[label])

    let existing = pieParts[label]
    if (existing) {
      existing.elapsed += elapsed
    } else {
      pieParts[label] = { label, elapsed }
    }
  }
  // console.log('perf_update|', elapsed + ' ms' + '|', label)
}

const reportUpdateTimings = () => {
  let parts = l.reverse(l.sortBy(pieParts, 'elapsed'))
  let parts2 = l.take(parts, 10)
  let parts3 = l.map(parts2, (c) => ({
    label: c.label,
    ms: c.elapsed,
  }))

  l.forEach(parts3, (c, cIdx) => {
    console.log(
      'perf|',
      'report|',
      cIdx + 1,
      c.label,
      '|',
      c.ms.toFixed(1),
      '|',
      (c.ms / updateFrames).toFixed(2),
    )
  })
  console.log('perf|', 'report|', updateFrames, 'frames')
}
